<script>
import router from "@/router";
import SelectTask from "@/components/SelectTask.vue";

export default {
    name: 'FormCISComplaint',

    components: {
        SelectTask, 
    },

    data() {
        return {
            title: 'KIS-Reklamation',
            table: 'cis_complaint',
            mainview: 'ListCISComplaints',
            id: '',
            name: '',
            phone: '',
            date: '',
            complaint: '',
            completed: 0,
            completed_by: '', 
            completed_at: '', 
            company: '', 
            cis_task_id: null,
            cis_user_id: null,
            cis_user_email: '', 
            isLoading: true,
            SelectTask: false,
        };
    },

    created() {
        if (this.$route.params.id) {
            this.id = this.$route.params.id;
            this.fetchCisComplaint();
        } else {
           
            const today = new Date();
            const day = String(today.getDate()).padStart(2, '0');
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const year = today.getFullYear();
            this.date = `${day}.${month}.${year}`;
            this.isLoading = false;  
        }

    },

    methods: {
        
        
        async fetchUserEmail(userId) {
          if (!userId) {
             console.error('No user ID provided');
             return;
           }

          const param = {
             table: "cis_user",
             statement: "select",
             type: "detail",
             where: "true",
             selector: "id",
             value: userId,
             short: "false",
             extension: ""
           };

          try {
             const result = await this.$func.queryAPI(param, {});
             if (result.length > 0) {
                const user = result[0];
                this.cis_user_email = user.email;
                 console.log('cis user email:', user.email);
              }
            } catch (error) {
                console.error('Error fetching user email:', error);
             }
        },
        async loadTask(taskId) {
          console.log('Task ID selected:', taskId);
          if (!taskId) {
            console.error('No task ID received');
            return;
          }
          const param = {
            table: "task",
            statement: "select",
            type: "detail",
            where: "true",
            selector: "id",
            value: taskId, 
            short: "false",
            extension: ""
          };

         try {
           const result = await this.$func.queryAPI(param, {});
           if (result.length > 0) {
             const task = result[0];

             this.cis_task_id = taskId || task.id;
             this.company = task.company;
             this.cis_user_id = task.cis_user_id;
             if (task.cis_user_id) {
               this.fetchUserEmail(task.cis_user_id);
             }

             
             console.log('Task details loaded:', task); 
          }
         } catch (error) {
            console.error('Error fetching task:', error);
         }

          this.SelectTask = false;
        },
  
        async checkedComplaint() {
            console.log('Checking CIS Complaint...');
            const param = {
                table: this.table,
                statement: 'update',
                type: 'detail',
                where: 'true',
                selector: 'id',
                value: this.id,
                short: 'false',
                extension: ''
            };            

            const data = {
                completed: 1,
                completed_by: localStorage.getItem('username') || '', 
                completed_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
            };

            try {
                const result = await this.$func.queryAPI(param, data);
                console.log('CIS Complaint checked:', result);
                this.$router.push({ name: this.mainview });
            } catch (error) {
                console.error('Error checking CIS Complaint:', error);
            }
        },

        async fetchCisComplaint() {
            console.log('Fetching CIS Complaint...');
            this.isLoading = true;  
            const param = {
                table: 'cis_complaint',
                statement: 'select',
                type: 'detail',
                where: 'true',
                selector: 'id',
                value: this.id,
                short: 'false',
                extension: ''
            };

            try {
                const result = await this.$func.queryAPI(param, {});
                if (result.length > 0) {
                    const complaint = result[0];
                    this.name = complaint.name;
                    this.phone = complaint.phone;
                    this.complaint = complaint.text;
                    this.completed = complaint.completed;
                    this.date = complaint.date; 
                    this.completed_by = complaint.completed_by; 
                    this.completed_at = complaint.completed_at;
                    this.company = complaint.company;
                    this.cis_task_id = complaint.cis_task_id?.toString() || null;
                    this.cis_user_id = complaint.cis_user_id?.toString() || null;
                    this.cis_user_email = complaint.cis_user_email || '';

                    console.log('Complaint details loaded:', complaint);
                }
            } catch (error) {
                console.error('Error fetching CIS Complaint:', error);
            } finally {
                this.isLoading = false;  
            }


            // alert('completed: ' + this.completed)

        },
 
        async saveData() {
            try {


                const param = {
                    table: this.table,
                    statement: this.id ? 'update' : 'insert',
                    type: '',
                    where: 'true' ,
                    selector:'id',
                    value: this.id ,
                    short: 'false',
                    extension: ''
                };
                const data = {
                    date: this.date,
                    name: this.name,
                    phone: this.phone,
                    text: this.complaint,
                    completed: this.completed,
                    cis_task_id: this.cis_task_id || null,
                    cis_user_id: this.cis_user_id || null,
                    company: this.company, 
                    cis_user_email: this.cis_user_email,

                };
              


                await this.$func.queryAPI(param, data);
                this.$router.push({ name: this.mainview });
            } catch (error) {
                console.error('Error saving complaint:', error);
            }
        },

        btnCancel() {
            router.push({ name: this.mainview });
        }
    },

    watch: {
        id: {
            immediate: true,
            handler(newId) {
                if (newId) this.fetchCisComplaint();
            }
        }
    }
};
</script>

<template>
    <v-layout>
        <v-card 
            class="mx-auto justify-center text-center"
            width="600"
            style="padding-top: 30px;"
            elevation="10" 
            >
            <v-card-title primary-title class="justify-center">
                <div>
                    <h3 class="headline text--accent-2">{{ title }}</h3>
                </div>
            </v-card-title>

            <v-form
            class="h-full overflow-y-scroll"
            >
              <v-text-field
                  v-model="date"
                  label="Datum"
                  placeholder="DD.MM.YYYY"
                  outlined
                  type="text"
                  autocomplete="off"
                  class="form-field mt-1"
                  disabled
              />

                <v-text-field 
                    v-model="name" 
                    label="Name" 
                    outlined 
                    type="text" 
                    autocomplete="off" 
                    class="form-field"
                />
                <v-text-field 
                    v-model="phone" 
                    label="Telefon"
                    outlined 
                    type="tel" 
                    autocomplete="off" 
                    class="form-field" 
                />

                <v-text-field
                    v-model="cis_task_id" 
                    item-text="name" 
                    item-value="id" 
                    label="Task ID"
                    outlined
                    disabled
                    class="form-field" 
                    :loading="isLoading" 
                 />
  
                 <v-btn
                  v-if="!cis_task_id"
                  @click="SelectTask = true"
                  style="margin: 30px;"
                 >
                <v-icon
                    style="padding-right: 5px;"
                >mdi-truck-delivery-outline</v-icon>
                Auftrag auswählen</v-btn>

               <v-btn
                  v-if="cis_task_id !== '' && cis_task_id !== null"
                  @click="$router.push({ path: '/FormTask/' + cis_task_id })"
                  style="margin: 30px;"
                >
                <v-icon
                    style="padding-right: 5px;"
                >mdi-truck-delivery-outline</v-icon>
                Auftrag ANSEHEN</v-btn>


              <v-text-field
                  v-model="company"
                  label="Firma"
                  outlined
                  disabled
                  class="form-field"
              />

                <v-text-field
                    v-model="cis_user_email"
                    label="KIS-Benutzer"
                    outlined
                    disabled
                    class="form-field"
                 />

                <v-textarea 
                     v-model="complaint" 
                     label="Reklamationstext"
                     outlined 
                     class="form-field"
                />


              <v-text-field
                  v-if="completed == 1"
                  v-model="completed_by"
                  label="Bearbeitet von"
                  outlined
                  disabled
                  class="form-field"
              />

              <v-text-field
                  v-if="completed == 1"
                  v-model="completed_at"
                  label="Bearbeitet am"
                  outlined
                  disabled
                  class="form-field"
              />

                <v-row class="my-3 mx-2">
                    <v-col class="text-left">
                        <v-btn v-if="completed == 0 && !isLoading" 
                            color="purple" 
                            elevation="2"
                            outlined 
                            @click="checkedComplaint">
                            Überprüft
                        </v-btn>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn 
                            color="red" 
                            elevation="2"
                            outlined 
                            class="mr-4" 
                            @click="btnCancel">
                            Abbrechen
                        </v-btn>
                        <v-btn v-if="completed == 0 && !isLoading"
                            color="green" 
                            elevation="2"
                            outlined 
                            @click="saveData">
                            Speichern
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card>

      <SelectTask
          v-if="SelectTask"
          @SelectedTask="loadTask"
          @SelectTaskClose="SelectTask = false"
      />

    </v-layout>
</template>

<style scoped>
.form-field {
    display: table;
    margin: 0 auto;
    width: 350px;
}
</style>